import { render, staticRenderFns } from "./AdvisorTradeReviewDetail.vue?vue&type=template&id=1b5253d6&scoped=true&"
import script from "./AdvisorTradeReviewDetail.vue?vue&type=script&lang=js&"
export * from "./AdvisorTradeReviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorTradeReviewDetail.vue?vue&type=style&index=0&id=1b5253d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5253d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VSkeletonLoader,VTextField})
